import { Box, Center, Image, Text, useColorModeValue } from "@chakra-ui/react";
import { skill } from "../utils/data";

import { Wrap, WrapItem } from "@chakra-ui/react";

const Skills = ({ dataSection }) => {
  const txtColor2 = useColorModeValue("black", "white");
  return (
    //
    <Box p={{ base: "15px", lg: "70px" }}>
      <Text
        fontSize="3xl"
        color="teal.500"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        mt={{ base: "20px", lg: "0px" }}
      >
        Skills
      </Text>
      <Text
        fontSize="sm"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        color={txtColor2}
        mb={15}
      >
        Here are some of my skills
      </Text>
      <Box display="flex" justifyContent="center" alignItems="center" my={10}>
        <Wrap
          spacing={{ base: "20px", lg: "40px" }}
          justify="center"
          align="center"
        >
          {skill.map((item, index) => (
            <WrapItem>
              <Box key={index}>
                <Center>
                  <Box display="flex" flexDirection="column">
                    <Image
                      src={item.img}
                      w={{ base: "62px", lg: 20 }}
                      h={{ base: "62px", lg: 20 }}
                    />
                    {/* <Box
                      justifyContent="center"
                      alignItems="center"
                      display="flex"
                      color={txtColor2}
                    >
                      {item.name}
                    </Box> */}
                  </Box>
                </Center>
              </Box>
            </WrapItem>
          ))}
        </Wrap>
      </Box>
    </Box>
  );
};

export default Skills;
